/* @jsxRuntime automatic */
/* @jsxImportSource @superweb/css */
import { Spin } from "@superweb/ui";

export const PageSpinner = () => (
  <div
    css={{
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <Spin />
  </div>
);
